import Logo from "../../assets/img/logo-light.png";
import Minipan from "../../assets/img/minipan.png";
import {useEffect} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {motion} from "framer-motion"
import {useDispatch} from "react-redux";
import {
  setCurrency,
  setCurrencySymbol,
  setGoogleCommentUrl,
  setIsGoogleComment,
  setIsOrderAvailable,
  setIsRequiredNoteScreen,
  setIsShowFeedbackForm,
  setLocale,
  setMenuId,
  setMenuInfo,
  setQrMenuStatus,
  setRestaurantId,
  setShowProductOptions,
  setTableId,
  setTheme,
  setThemeOption,
} from "../../storage/app";
import {useGetMenuInfoQuery} from "../../storage/api";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";


const SplashScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {restaurantId} = useParams();
  const [searchParams] = useSearchParams();
  const tableId = searchParams.get('table_id');
  const menuId = searchParams.get('menu_id');
  const option = searchParams.get('theme_option');
  const queryTheme = searchParams.get('theme');
  const MySwal = withReactContent(Swal)

  useEffect(() => {
    dispatch(setTableId(tableId));
    dispatch(setRestaurantId(restaurantId));
    dispatch(setMenuId(menuId));
    dispatch(setThemeOption(option || 'option-1'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restaurantId, tableId, menuId]);

  const {data, error, isLoading} = useGetMenuInfoQuery({menuId, tableId});

  useEffect(() => {
    if (error) {
      MySwal.fire({
        icon: 'error',
        title: 'Hata!',
        html: 'Menü Bulunamadı!',
        showCancelButton: false,
        showConfirmButton: false,
        confirmButtonText: 'Tamam',
        allowOutsideClick: false,
        backdrop: false,
      }).then((result) => {

      })
    } else {
      if (!isLoading) {
        if (data.default_locale) {
          dispatch(setLocale(data.default_locale))
        }
        dispatch(setMenuInfo(data))
        dispatch(setCurrency(data?.currency || 'TRY'))
        dispatch(setCurrencySymbol(data?.currencySymbol || '₺'))
        dispatch(setIsShowFeedbackForm(data?.feedback_form_enabled))
        dispatch(setIsRequiredNoteScreen(data?.name_required_for_order))
        dispatch(setIsGoogleComment(data?.is_google_comment || false))
        if (data?.is_google_comment) {
          dispatch(setGoogleCommentUrl(data?.google_comment_url || ''))
        }
        dispatch(setIsOrderAvailable(data?.allow_order && Boolean(tableId)))
        dispatch(setShowProductOptions(data?.show_product_options || data?.allow_order))
        dispatch(setTheme(queryTheme || data?.theme))
        dispatch(setQrMenuStatus(data?.qr_menu_status))

        if (Boolean(data)) {
          setTimeout(() => {
            if (data?.qr_menu_status === false)
              return navigate('/qr-menu-not-available');
            return navigate("/home");
          }, 1500);
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, error])

  const minipanIds = [
    "fcbe7bd5-85c0-4515-94c4-a4c01c7fe98c",
    "441cb8a0-15d6-4df7-84ff-3c45938bdebe",
    "908b104d-814d-4a33-8c38-b4c99e0d8699",
    "09137419-a8cf-4db0-8efe-0074d24d597d",
    "8bd2b802-9b35-4906-94c6-a3c884bbd909",
    "39b93c92-d3ee-468b-98ee-17b323ed814a",
    "73e00fc8-bab6-4693-9777-bdf276309799",
    "5c497c43-1288-448e-b636-6f322ea9ab5f",
    "d9d8c614-7910-4621-a1f3-162fc9b0c176",
    "31fac5f9-97bb-42a9-8053-73032e038296"
  ]

  return (
    <div className={'bg-[#021321] text-white h-screen w-full flex justify-center items-center'} style={{}}>
      <motion.div
        className={'flex justify-center items-center'}
        initial={{opacity: 0, scale: 0.5}}
        animate={{opacity: 1, scale: 1}}
        transition={{duration: 1}}>
        {minipanIds.includes(restaurantId) ? (
          <>
            <img src={Minipan} width={'60%'} alt={'Minipan'}/>
          </>
        ) : (
          <>
            <img src={Logo} width={'60%'} alt={'Logo'}/>
          </>
        )}
      </motion.div>
    </div>
  )
}

export default SplashScreen;
